import { trackingLoadedForShop } from '~/utils/trackingScope'

/**
 * Once a shop's tags are loaded, leaving that shop through client-side
 * navigation does a full page load so the next shop starts without them.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const { shopSlugFor } = useTrackingScope()

  router.beforeEach((to) => {
    const loadedFor = trackingLoadedForShop()
    if (loadedFor === null || shopSlugFor(to) === loadedFor) return
    window.location.assign(router.resolve(to.fullPath).href)
    return false
  })
})
